module.exports = __webpack_public_path__ + "media/images/restaurant/011_pandora_zh_hant-96e356f15a8f752e8f7d95018e54ce5c.jpg";